"use client";

import { getTranslatedLink } from "@/components/UI/Link/TranslatedLink";
import { useScopedI18n } from "@/i18n/client";
import Link from "next/link";
import { FC } from "react";
import styles from "./Tags.module.scss";
import { ArticleEntryType } from "@/lib/builder/server-quries";

interface TagsProps {
	location: ArticleEntryType;
	tags: Array<string>;
}

const Tags: FC<TagsProps> = ({ tags = [], location }) => {
	if (typeof tags === "string") {
		tags = (tags as string).split(",").map((tag) => tag.trim());
	}

	const scopedT = useScopedI18n("blog");

	if (!tags) {
		return null;
	}

	return (
		<div className={styles.tags}>
			{tags.map((tag: string, index: number) => {
				const tagChecker = `?${scopedT("tag").toLowerCase()}=${tag}`;

				return (
					<Link
						key={`${tag}-${index}`}
						className={styles.item}
						href={`${getTranslatedLink({ href: location })}${tagChecker}`}
						aria-label={`${scopedT("viewAllArticlesOn")}${tag}`}
					>
						{tag}
					</Link>
				);
			})}
		</div>
	);
};

export default Tags;
